import axios, { isCancel } from "axios";
import Select from "react-select";
import config from "../../../config/config";

import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { uploadAWS } from "../../../common/AWSHelper";
import Loader from "../../../components/Loader/Loader";
import { AWS_IMAGE_FOLDER_SALES } from "../../../common/Constant";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_RECEIVING,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import moment from "moment";

const ReceivePayment = () => {
  let navigate = useNavigate();
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const locationId = localStorage.getItem("Location");
  let CATotal;
  const [loading, setLoading] = useState(false);
  const [todayDate, setTodayDate] = useState(moment().format('YYYY-MM-DD'));
  const [FileUrl, setFileUrl] = useState("");
  const [payment, setPayment] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [amountToApply, setAmountToApply] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [amountReceived, setAmountReceived] = useState(-1);
  const [creditSubValue, setCreditSubValue] = useState(0);
  const [creditAmountValue, setCreditAmountValue] = useState(0);
  const [customerInvoiceData, setCustomerInvoiceData] = useState([]);
  const [btnFileLoader, setBtnFileLoader] = useState({ Receipt: false });
  const [totalCredit, setTotalCredit] = useState(0);
  const [allCreditApplied, setAllCreditApplied] = useState(0);
  const [showDepositToError, setShowdepositToError] = useState(false);
  const [showTodayDateError, setShowTodayDateError] = useState(false);
  const [showAmountReceivedError, setShowAmountReceivedError] = useState(false);
  const [showAccountSelectError, setShowAccountSelectError] = useState(false);
  const [showAvailableCreditError, setShowAvailableCreditError] =
    useState(false);
  const [paymentTotal, setPaymentTotal] = useState(0);
  const [customerId, setCustomerId] = useState();
  const [depositTo, setDepositTo] = useState();
  const [attachmentUrl, setAttachmentUrl] = useState();
  const [memoData, setMemoData] = useState("");

  const [dataById, setDataById] = useState({});
  const [paymentValue, setPaymentValue] = useState("");

  console.log(customerInvoiceData, "customerInvoiceData");
  console.log(showDepositToError, "showdepositToError");
  // For CheckBox
  const [checkedItems, setCheckedItems] = useState([]);
  const [showAppliedCredit, setShowAppliedCredit] = useState(0);
  const [errorIndex, setErrorIndex] = useState(0);

  // const handleHeaderCheckboxChange = (event) => {
  //   const isChecked = event.target.checked;
  //   if (isChecked) {
  //     // Check all checkboxes
  //     setCheckedItems(customerInvoiceData);
  //   } else {
  //     // Uncheck all checkboxes
  //     setCheckedItems([]);
  //   }
  // };

  console.log(paymentValue, "paymentValue");
  // const handleCheckboxChange = (event, invoice) => {
  //   const isChecked = event.target.checked;
  //   if (isChecked) {
  //     // Add invoice to checked items
  //     setCheckedItems([...checkedItems, invoice]);
  //   } else {
  //     // Remove invoice from checked items
  //     const updatedCheckedItems = checkedItems.filter(
  //       (item) => item !== invoice
  //     );
  //     setCheckedItems(updatedCheckedItems);
  //   }
  // };

  console.log("paymentDate 4545", todayDate);
  const [depositToAccount, setDepositToAccount] = useState([]);
  useEffect(() => {
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl?type=3,4`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("ChartOfAccountDropdown", res.data.ResponseData);
        const mappedReceivingItems = res.data.ResponseData.map((item) => {
          const mappedItem = {
            label: item.Name,
            value: item.ID,
            Amount: item.Amount,
          };
          return mappedItem;
        });
        // setStateNew(mappedReceivingItems);
        setDepositToAccount(mappedReceivingItems);
        // return res;
      })
      .catch((err) => {
        console.log(err);
      });

    if (paramObject?.id > 0) {
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/receivepaymentdetails?id=${paramObject?.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("get receiving paymentdata by id", res.data.ResponseData);
          const data = res.data.ResponseData[0];
          // console.log(newrowsdata[0]?.Paymentdate, "paymentDate")
          // setDataById(data);
          setCustomerId(data?.CustomerId);
          setTodayDate(data?.Paymentdate);
          setDepositTo(data?.AccountId);
          setAttachmentUrl(data?.Attachment);
          setMemoData(data?.Memo);
          setTotalCredit(data?.CustomersBalance);
          setPaymentValue(data?.Paymentamount);

          console.log(data, "data774411");
          setCustomerInvoiceData([
            {
              ID: data?.ID,
              InvoiceNo: data?.InvoiceNo,
              DueDate: data?.DueDate,
              CreatedDate: data?.Paymentdate,
              OriginalAmount: data?.OriginalAmount,
              Openingbalance: data?.OpeningBalance,
              CreditApplied: data?.CustomersBalance,
              Payment: Number(data?.Paymentamount).toFixed(2),
              CreditAppiedValue: Number(data?.CreditApplied).toFixed(2),
              isChecked: true,
              PaymentMethod: data?.PaymenttypeId,
              ReferenceNumber: data?.Refno,
              SaleId: data?.SaleId,
            },
          ]);

          setFormValues((prevValues) => ({
            ...prevValues,
            ["Customer"]: data?.CustomerId,
            ["DepositTo"]: data?.AccountId,
          }));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  console.log("depositToAccount::>>", depositToAccount);

  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      // Check all checkboxes
      const updatedCheckedItems = customerInvoiceData.map((item) => ({
        ...item,
        isChecked: true,
      }));
      // setCheckedItems(updatedCheckedItems);
      setCustomerInvoiceData(updatedCheckedItems);
    } else {
      // Uncheck all checkboxes
      // setCheckedItems([]);
      const updatedCustomerInvoiceData = customerInvoiceData.map((item) => ({
        ...item,
        // Payment: 0,
        // CreditAppiedValue: 0,
        isChecked: false,
      }));
      setCustomerInvoiceData(updatedCustomerInvoiceData);
      setCheckedItems([]);
    }
  };

  //   console.log("event", event);
  //   if (isChecked) {
  //     // Add invoice to checked items with Payment set to OpeningBalance
  //     // const updatedInvoice = {
  //     //   ...customerInvoiceData[index],
  //     //   Payment: customerInvoiceData[index]?.Openingbalance,
  //     // };
  //     // setCheckedItems([...checkedItems, updatedInvoice]);
  //     const updatedData = [...customerInvoiceData];
  //     updatedData[index] = {
  //       ...updatedData[index],
  //       Payment: customerInvoiceData[index]?.Openingbalance,
  //     };
  //     setCheckedItems(updatedData);
  //   } else {
  //     // Remove invoice from checked items
  //     const updatedCheckedItems = checkedItems.filter(
  //       (item) => item.ID == customerInvoiceData[index].ID
  //     );
  //     setCheckedItems(updatedCheckedItems);
  //   }
  // };
  // const handleCheckboxChange = (event, index) => {
  //   const checkedItemsCopy = [...checkedItems];

  //   if (event.target.checked) {
  //     const selectedInvoice = checkedItemsCopy[index];
  //     selectedInvoice.Payment = parseFloat(selectedInvoice?.Openingbalance);
  //     checkedItemsCopy[index] = selectedInvoice;
  //   } else {
  //     const selectedInvoice = checkedItemsCopy[index];
  //     selectedInvoice.Payment = 0;
  //     checkedItemsCopy[index] = selectedInvoice;
  //   }

  //   setCheckedItems(checkedItemsCopy);
  // };

  const handleCheckboxChange = (event, index, itemRowData) => {
    if (event.target.checked) {
      const updatedDataNew = [...customerInvoiceData];
      updatedDataNew[index] = {
        ...updatedDataNew[index],
        isChecked: true,
      };
      setCustomerInvoiceData(updatedDataNew);
    } else {
      const updatedDataNew = [...customerInvoiceData];
      updatedDataNew[index] = {
        ...updatedDataNew[index],
        isChecked: false,
      };
      setCustomerInvoiceData(updatedDataNew);
    }
  };

  // console.log("customerInvoiceData", customerInvoiceData);
  // console.log("CheckedItems", checkedItems);
  const handlePayment = (event, index) => {
    setErrorIndex(index);
    const checkedItemsCopy = [...customerInvoiceData];
    const selectedInvoice = checkedItemsCopy[index];

    // console.log(creditSubValue, "creditSubValuetest")
    // if(creditSubValue <= 0){
    //   selectedInvoice.Payment = 0
    // }else{
    // selectedInvoice.Payment = parseFloat(
    //   event.target.value ? event.target.value : ""
    //   );
    // }

    // console.log(event.target.value ,  selectedInvoice.Openingbalance, "Payment log")
    if (event.target.value <= selectedInvoice.Openingbalance) {
      // console.log(event.target.value ,  selectedInvoice.Openingbalance, "Payment log")
      selectedInvoice.Payment = parseFloat(
        event.target.value ? event.target.value : ""
      );
    }

    console.log(typeof event.target.value, "paymentinput");
    selectedInvoice.isChecked = true;

    checkedItemsCopy[index] = selectedInvoice;
    setCustomerInvoiceData(checkedItemsCopy);
  };

  const [formValues, setFormValues] = useState({
    Customer: "",
    DepositTo: "",
    ReferenceNumber: "",
    PaymentMethod: "",
    InvoiceNumber: "",
    Memo: "",
  });

  // Styles
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };

  //   Customer Drop Down
  let customerOption = [];
  const customerDropdown = customer.map((u, i) => {
    customerOption[i] = {
      // label: u.FirstName + " " + u.LastName,
      label: u.CompanyName + " (" + (u.FirstName + " " + u.LastName) + ")",
      value: u.Id,
    };
  });

  //   Payment Method Drop Down
  let paymentMethodOption = [];
  const payementDropdown = paymentMethod.map((u, i) => {
    paymentMethodOption[i] = {
      label: u.Paymenttypename,
      value: u.ID,
    };
  });

  //   Deposit To Drop Down
  let depositToOption = [
    { label: "SBI", value: 1 },
    { label: "BOB", value: 2 },
  ];

  // Validation for the file upload
  const vaidation = (name, value) => {
    switch (name) {
      case "Attachment":
        if (!value.name.match(/\.(jpg|jpeg|png|pdf|heic)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  // Upload function for uploading the file on AWS
  const uploadFilePDF = async (file, type, index) => {
    setBtnFileLoader({ [type]: true });
    setLoading(true);

    await uploadAWS(file, AWS_IMAGE_FOLDER_SALES, (data) => {
      if (data) {
        if (type === "Attachment") {
          setFileUrl(data);
          setLoading(false);
        }
      }
    });
  };

  // Handle the for the file change
  const handleFileChange = (event, index) => {
    if (vaidation(event.target.name, event?.currentTarget?.files[0])) {
      // console.log(event.currentTarget.files[0]);
      uploadFilePDF(event?.currentTarget?.files[0], event.target.name, index);
    }

    const files = event.target.files;
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };

  // Payment Method Drop Down Binding API CALL
  const PaymentMethodAPI = () => {
    axios
      .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })

      .then((res) => {
        setLoading(true);
        setPaymentMethod(res.data.ResponseData);
        setLoading(false);
      });
  };

  // Customer Drop Down Binding API CALL
  const CustomerAPI = () => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(true);
        setCustomer(res.data.ResponseData);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const ParticularCustomerInvoiceAPI = (p_customerid, p_invoicenumber) => {
    axios
      .get(
        `${
          config.salesconfigBaseUrl
        }/sales/customersinvoicelist?customerid=${p_customerid}&invoiceno=${
          p_invoicenumber ? p_invoicenumber : ""
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(true);
        const mappedReceivingItems = res.data.ResponseData.map((item) => {
          return {
            ...item,
            Payment: null,
            Openingbalance: Number(item?.Openingbalance),
            OriginalAmount: Number(item?.OriginalAmount),
            CreditAppiedValue: null,
            isChecked: false,
            PaymentMethod: 0,
          };
        });

        console.log("mappedReceivingItems", mappedReceivingItems);

        // setStateNew(mappedReceivingItems);
        setTotalCredit(mappedReceivingItems[0]?.CreditApplied);
        setCustomerInvoiceData(mappedReceivingItems);
        // console.log(res.data.ResponseData);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  console.log("customerInvoiceData::>>", customerInvoiceData);

  useEffect(() => {
    const CreditAppiedTotal = customerInvoiceData.reduce((acc, curr) => {
      acc =
        acc +
        (Number(curr.CreditAppiedValue) == null
          ? 0
          : Number(curr.CreditAppiedValue));
      return acc;
    }, 0);

    CATotal = totalCredit - CreditAppiedTotal;
    console.log(CATotal, "CATotal");
    // allCreditApplied = (totalCredit - CreditAppiedTotal);
    if (CATotal < 0) {
      setShowAvailableCreditError(false);
      // toastWarn("Invalid Credit Applied Add More Fund");
    } else {
      setShowAvailableCreditError(true);
    }
    setAllCreditApplied(CATotal);
    setShowAppliedCredit(CreditAppiedTotal);

    // console.log(allCreditApplied, "CreditAppiedTotal");
  }, [customerInvoiceData]);

  console.log(allCreditApplied, "CreditAppiedTotal");
  // Handle the cancel to redirect it to sales list
  const handleCancel = () => {
    navigate("/sales");
  };

  console.log(totalCredit, "totalCredit");

  // handle change for all the input fields
  const handleChangeInput = (event, fieldName, index) => {
    // console.log(event, fieldName, index, "change event")
    if (fieldName === "Customer") {
      console.log(event?.value, fieldName, "customer 456");
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event?.value,
      }));

      ParticularCustomerInvoiceAPI(event?.value);
      setCustomerId(event?.value);

      if (event?.value != undefined) {
        setShowAccountSelectError(false);
      } else {
        setShowAccountSelectError(true);
      }
    } else if (fieldName === "DepositTo") {
      // console.log(event.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event?.value,
      }));
      if (event?.value != undefined) {
        // setShowError({...showError, depositTo: false})
        setShowdepositToError(false);
      } else {
        // setShowError({...showError, depositTo: true})
        setShowdepositToError(true);
      }

      setDepositTo(event?.value);
    } else if (fieldName === "ReferenceNumber") {
      // console.log(event.target.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.target.value,
      }));
      const { value } = event.target;
      setCustomerInvoiceData((prevData) => {
        const newData = [...prevData];
        newData[index] = { ...newData[index], [fieldName]: value };
        return newData;
      });
    } else if (fieldName === "CreditAppiedValue") {
      console.log(
        event.target.value,
        fieldName,
        customerInvoiceData[index].Openingbalance
      );
      if (
        Number(event.target.value) <=
        Number(customerInvoiceData[index].Openingbalance)
      ) {
        setFormValues((prevValues) => ({
          ...prevValues,
          [fieldName]: Number(event.target.value),
          ["isChecked"]: true,
        }));

        const { value } = event.target;
        console.log(value, "value===>");
        // let TotalBal = customerInvoiceData[index].CreditApplied;

        setCustomerInvoiceData((prevData) => {
          const newData = [...prevData];

          newData[index] = {
            ...newData[index],
            [fieldName]: value == "" ? "" : Number(value),
            ["isChecked"]: true,
            ["Payment"]:
              parseFloat(newData[index].Openingbalance) -
              // (Number(value)),
              (value == "" ? "" : Number(value)),
          };
          return newData;
        });
        setPaymentValue(
          customerInvoiceData[index]?.Openingbalance - Number(value)
        );
        //toastWarn("Invalid Credit Applied Add More Fund");
      }
    } else if (fieldName === "PaymentMethod") {
      // console.log(event.value, fieldName);
      // const { value } = event.value;
      setCustomerInvoiceData((prevData) => {
        const newData = [...prevData];
        newData[index] = {
          ...newData[index],
          [fieldName]: event.value,
          ["isChecked"]: true,
        };
        return newData;
      });
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.value,
        ["isChecked"]: true,
      }));
    } else if (fieldName === "InvoiceNumber") {
      // console.log(event.target.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.target.value,
      }));
    } else if (fieldName === "Memo") {
      // console.log(event.target.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.target.value,
      }));
    } else if (fieldName === "PaymentDate") {
      // console.log(event.target.value, fieldName);
      setTodayDate(event.target.value);
      if (event.target.value != "") {
        // setShowError({...showError, todayDate: false})
        showTodayDateError(false);
      } else {
        // setShowError({...showError, todayDate: true})
        showTodayDateError(false);
      }
    } else if (fieldName === "AmountReceived") {
      console.log(event.target.value, fieldName, "558");
      console.log(paymentTotal - event.target.value, "total credit amount");
      // setCreditSubValue(Math.abs(paymentTotal - event.target.value))
      setCreditAmountValue(event.target.value);
      console.log(
        Number(event.target.value == "" ? 0 : event.target.value),
        "556"
      );
      setAmountReceived(
        Number(event.target.value == "" ? 0 : event.target.value)
      );
      if (event.target.value > 0) {
        // setShowError({...showError, amountReceived: false})
        setShowAmountReceivedError(false);
      } else {
        setShowAmountReceivedError(true);
        // setShowError({...showError, amountReceived: true})
      }
    } else {
      console.log("No Condition");
    }
  };

  const handleFindData = () => {
    ParticularCustomerInvoiceAPI(formValues.Customer, formValues.InvoiceNumber);
  };

  console.log(formValues, "formValues");
  console.log("amountReceived ==> 1122", amountReceived);
  console.log("paymentTotal 1122", paymentTotal);

  console.log("Attactment ==> ", FileUrl);
  console.log("todayDate ==> ", todayDate == "" ? 0 : todayDate);
  // console.log("DepositTo ==> ", formValues.DepositTo != undefined ? (formValues.DepositTo == "" ? 0: formValues.DepositTo): 0 )
  console.log("DepositTo ==> ", formValues.DepositTo?.length);

  // Handle submit to post the data
  const handleSubmit = (e, values) => {
    console.log(e, values, "values648");
    // For Changing the name of the Objects

    if (creditSubValue < 0) {
      toastError("Add more Receive Amount");
      return;
    }

    const filteredData = customerInvoiceData.filter(
      (el) => el.isChecked == true
    );

    const checkPaymentMethodSelect = filteredData.filter(
      (el) => el.PaymentMethod == 0
    );

    const mappedReceivingItems = filteredData.map((item) => {
      const mappedItem = {
        ID: paramObject?.id > 0 ? paramObject?.id : 0,
        BillId: paramObject?.id > 0 ? item.SaleId : item.ID,
        DueDate: item.DueDate,
        OriganlAmount: item.OriginalAmount,
        // ItemName: item.Items,
        CreditApplied: item.CreditAppiedValue,
        Payment: parseFloat(item.Payment),
        RefNo: parseInt(item.ReferenceNumber),
        PaymentmethodId: parseInt(item.PaymentMethod),
      };
      // console.log(mappedItem);
      return mappedItem;
    });
    // For Changing the name of the Objects

    // For Xml
    // let WorkOrderItemData = mappedReceivingItems.filter(function (
    //   workOrderItem
    // ) {
    //   return workOrderItem.isChecked == true;
    // });

    console.log(mappedReceivingItems, "mappedReceivingItems");
    const workOrderItemobj = {};
    workOrderItemobj.XMLBill = mappedReceivingItems;
    let workorderitemjsonstring = JSON.stringify(workOrderItemobj);
    // console.log("workorderitemjsonstring: ", workorderitemjsonstring);
    // console.log("FormValues ==> ", formValues);
    // console.log("amountReceived ==> ", amountReceived);
    // console.log("Attactment ==> ", FileUrl);
    // console.log("Payment Date ==> ", todayDate);
    // console.log("Valuesss::>>", customerInvoiceData);
    // For Xml

    // Object To send it into axios

    const SubmitData = {
      xmlImportData: workorderitemjsonstring,
      CustomerID: formValues.Customer,
      PaymentDate: moment(todayDate).format('YYYY-MM-DD'),
      DepositTo: formValues.DepositTo,
      Memo: formValues.Memo,
      AttechMents: FileUrl,
      AmountReceived: amountReceived == -1 ? paymentTotal : amountReceived,
      LogninUser: parseInt(Id),
      id: paramObject.id ? Number(paramObject.id) : 0,
    };
    console.log("SubmitData::>>", SubmitData);

    if (
      todayDate == "" ||
      formValues.DepositTo == undefined ||
      formValues.DepositTo == "" ||
      // SubmitData.AmountReceived == 0 ||
      formValues.Customer == "" ||
      // paymentTotal == 0 ||
      checkPaymentMethodSelect?.length > 0
    ) {
      if (formValues.DepositTo === undefined) {
        console.log("SubmitData::>> Deposit undefine 456");
        // setShowError({...showError, depositTo: true})
        setShowdepositToError(true);
      }
      if (formValues.DepositTo === "") {
        console.log("SubmitData::>> Deposit null 456");
        // setShowError({...showError, depositTo: true})
        setShowdepositToError(true);
      }

      if (SubmitData.AmountReceived == 0) setShowAmountReceivedError(true);

      // if (paymentTotal == 0) {
      //   toastError("Please fill the Payment");
      // }

      if (todayDate === "") {
        console.log("SubmitData::>> Todaydate 456");
        // setShowError({...showError, todayDate: true})
        setShowTodayDateError(true);
      }
      if (formValues.Customer === "") {
        console.log("SubmitData::>> accountSelect 456");
        // setShowError({...showError, todayDate: true})
        setShowAccountSelectError(true);
      }
      if (checkPaymentMethodSelect?.length > 0) {
        toastError("Please Select Payment Method");
      }

      // setShowError({...showError, abc: true})
      console.log(123, "sss");
      return;
    }

    // if (creditSubValue <= 0) {
    //   setShowAmountReceivedError(true);
    //   toastError("Please fill the Amount Received");
    //   return;
    // }

    // Object To send it into axios
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/salesreceivingsupsert`,
        SubmitData,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setLoading(false);
          toastSuccess(SUCCESS_MESSAGE);
          if (paramObject.id > 0 && values == "saveandclose") {
            navigate("/transaction-log");
          } else if (values == "saveandclose" && paramObject.id == undefined) {
            navigate("/sales");
          } else {
            navigate("/receive-payment");
            window.location.reload();
          }
          // navigate("/sales")
          // else{
          // }

          console.log("res.data.ResponseID", res.data.ResponseID);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID < 0
        ) {
          toastError(ERROR_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  console.log(paramObject?.id, "paramID");
  useEffect(() => {
    PaymentMethodAPI();
    CustomerAPI();
    if (paramObject?.id == undefined) {
      ParticularCustomerInvoiceAPI();
    }
  }, []);

  useEffect(() => {
    let total = 0;
    for (let i = 0; i < customerInvoiceData.length; i++) {
      if (customerInvoiceData[i].isChecked) {
        total =
          total +
          (customerInvoiceData[i].Payment
            ? Number(customerInvoiceData[i].Payment)
            : 0);
      }
    }
    setPaymentTotal(total);
    // setAmountReceived(total);
  }, [customerInvoiceData]);

  useEffect(() => {
    setCreditSubValue(
      (Number(amountReceived) == -1
        ? Number(paymentTotal)
        : Number(amountReceived)) - Number(paymentTotal)
    );

    if (
      (Number(amountReceived) == -1
        ? Number(paymentTotal)
        : Number(amountReceived)) -
        Number(paymentTotal) <
      0
    ) {
      const checkedItemsCopy = [...customerInvoiceData];
      const selectedInvoice = checkedItemsCopy[errorIndex];

      if (selectedInvoice) {
        selectedInvoice.Payment = 0;
        checkedItemsCopy[errorIndex] = selectedInvoice;
        setCustomerInvoiceData(checkedItemsCopy);
        toastError("Add more Receive Amount");
      } else {
        // Handle the case when selectedInvoice is undefined
        console.error("selectedInvoice is undefined");
      }
    }
  }, [
    paymentTotal,
    // creditAmountValue
  ]);

  useEffect(() => {
    setCreditSubValue(
      (Number(amountReceived) == -1
        ? Number(paymentTotal)
        : Number(amountReceived)) - Number(paymentTotal)
    );

    // if (
    //   (Number(amountReceived) == -1
    //     ? Number(paymentTotal)
    //     : Number(amountReceived)) -
    //     Number(paymentTotal) <
    //   0
    // ) {
    // const checkedItemsCopy = [...customerInvoiceData];
    // const selectedInvoice = checkedItemsCopy[errorIndex];

    // if (selectedInvoice) {
    //   // selectedInvoice.Payment = 0;
    //   checkedItemsCopy[errorIndex] = selectedInvoice;
    //   setCustomerInvoiceData(checkedItemsCopy);
    // toastError("Add more Receive Amount");
    // } else {
    //   // Handle the case when selectedInvoice is undefined
    //   console.error("selectedInvoice is undefined");
    // }
    // }
  }, [creditAmountValue]);

  console.log(creditSubValue, "creditsubvalue");
  console.log(customerInvoiceData, "customerinvoicedata");

  const isNumber = (evt) => {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  };

  const handleKeyPress = (event) => {
    if (!isNumber(event)) {
      event.preventDefault();
    }
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Sales</h3>
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/sales">Sales List</Link>
                </li>
                <li className="breadcrumb-item active">Receive Payment</li>
              </ul>
            </div>
          </div>

          {/* Receive Payment Card */}
          <div className="card">
            <div className="card-body">
              {/* First Row */}
              <div className="d-flex flex-row col-md-12">
                {/* Customer Drop Down */}
                <div className="ml-2 col-md-4">
                  <Select
                    options={customerOption}
                    placeholder="Select Customer"
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={selectStyles}
                    id="Customer"
                    name="Customer"
                    onChange={(event) => handleChangeInput(event, "Customer")}
                    value={customerOption.find((option) => {
                      return option.value === customerId;
                    })}
                    className="custom-search-select"
                  />
                  {showAccountSelectError && (
                    <p className="text-danger mb-0">
                      * Customer field is required
                    </p>
                  )}
                </div>
                {/* InvoiceNumber */}
                <div className="ml-2 col-md-2">
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    placeholder="Find by invoice no."
                    name="InvoiceNumber"
                    onChange={(event) =>
                      handleChangeInput(event, "InvoiceNumber")
                    }
                  ></input>
                </div>
                {/* Find */}
                <div className="ml-2 col-md-2">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={handleFindData}
                    name="Find"
                  >
                    Find Data
                  </button>
                </div>
                {/* Amount Received Display */}
                <div className="col-md-2"></div>
                <div className="ml-2 col-md-2 pull-left">
                  <h6>Amount Recevied:</h6>
                  {/* <h3 className="fw-bolder">${amountReceived}</h3> */}
                  <h3 className="fw-bolder">
                    $
                    {parseFloat(
                      amountReceived == -1
                        ? parseInt(paymentTotal).toFixed(2)
                        : amountReceived
                    ).toFixed(2)}
                  </h3>
                </div>
              </div>

              {/* Second Row */}
              <div className="d-flex flex-row col-md-12">
                {/* Payment Date */}
                <div className="ml-2 col-md-2">
                  Payment Date:
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    id="PaymentDate"
                    name="PaymentDate"
                    value={moment(todayDate).format('YYYY-MM-DD')}
                    onChange={(event) =>
                      handleChangeInput(event, "PaymentDate")
                    }
                  />
                </div>
                {showTodayDateError && (
                  <p className="text-danger mb-0">* Payment Date is required</p>
                )}
                {/* Payment Method */}
                {/* <div className="p-2 col-md-2">
                  Payment Method:
                  <Select
                    options={paymentMethodOption}
                    placeholder="Select Payment Method"
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={selectStyles}
                    id="PaymentMethod"
                    name="PaymentMethod"
                    onChange={(event) =>
                      handleChangeInput(event, "PaymentMethod")
                    }
                  />
                </div> */}
                {/* Reference Number */}
                {/* <div className="p-2 col-md-2">
                  Reference Number:
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter the Reference No."
                    name="ReferenceNumber"
                    id="ReferenceNumber"
                    onChange={(event) =>
                      handleChangeInput(event, "ReferenceNumber")
                    }
                  ></input>
                </div> */}
                {/* Deposit To */}
                <div className="ml-2 col-md-4">
                  Deposit To:
                  <Select
                    // options={depositToOption}
                    options={depositToAccount}
                    placeholder="Select a Account"
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={selectStyles}
                    id="DepositTo"
                    name="DepositTo"
                    onChange={(event) => handleChangeInput(event, "DepositTo")}
                    value={depositToAccount.find((option) => {
                      return option.value === depositTo;
                    })}
                    className="custom-search-select"
                  />
                  {showDepositToError && (
                    <p className="text-danger mb-0">* Deposit is required</p>
                  )}
                </div>
                <div className="ml-2 col-md-4"></div>
                {/* Amount Received Input */}
                <div className="ml-2 col-md">
                  Amount Received:
                  {amountReceived == -1 ? (
                    <>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        // defaultValue={0.0}
                        name="AmountReceived"
                        id="AmountReceived"
                        value={paymentTotal}
                        // defaultValue={paymentTotal}
                        onChange={(event) =>
                          handleChangeInput(event, "AmountReceived")
                        }
                      ></input>
                      {/* {showAmountReceivedError && paymentTotal == 0 && (
                        <p className="text-danger mb-0">
                          * Amount Received is required and Greater then 0
                        </p>
                      )} */}
                    </>
                  ) : (
                    <>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        // defaultValue={0.0}
                        name="AmountReceived"
                        id="AmountReceived"
                        value={amountReceived == 0 ? "" : amountReceived}
                        // defaultValue={paymentTotal}
                        onChange={(event) =>
                          handleChangeInput(event, "AmountReceived")
                        }
                      ></input>
                      {showAmountReceivedError && (
                        <p className="text-danger mb-0">
                          * Amount Received is required and Greater then 0
                        </p>
                      )}
                    </>
                  )}
                  {/* {amountReceived<0 && */}
                  {/* {showAmountReceivedError && (
                    <p className="text-danger mb-0">
                      * Amount Received is required and Greater then 0
                    </p>
                  )} */}
                  {/* {amountReceived < 0 && <p className="text-danger mb-0">
                  * Amount Received is Greater then 0
                </p>} */}
                </div>
              </div>
            </div>
          </div>

          {/* Receive Payment Table Card */}
          <div className="card">
            <div className="card-body" style={{ padding: "8px" }}>
              {/* Outstanding Transactions Table */}
              {customerInvoiceData.length > 0 === true && (
                <>
                  <label className="form-check-label mt-2 mb-3">
                    Outstanding Transactions:
                  </label>
                  <div>
                    <table className="table ">
                      <thead>
                        <tr>
                          {/* <th>
                            <input
                              type="checkbox"
                              // onChange={handleHeaderCheckboxChange}
                              onChange={handleHeaderCheckboxChange}
                              checked={
                                checkedItems.length ===
                                customerInvoiceData.length
                              }
                            ></input>
                          </th> */}
                          <th>
                            <input
                              type="checkbox"
                              onChange={handleHeaderCheckboxChange}
                              checked={
                                customerInvoiceData.length ==
                                customerInvoiceData.filter(
                                  (el) => el.isChecked == true
                                ).length
                              }
                              // checked={
                              //   checkedItems.length ===
                              //   customerInvoiceData.length
                              // }
                            />
                          </th>
                          <th>Invoice</th>
                          <th>Due Date</th>
                          <th>Payment Method</th>
                          <th>Ref No.</th>
                          <th className="text-right">Original Amt.</th>
                          <th className="text-right">Open Bal.</th>
                          <th>Wallet Credit</th>
                          <th>Payment</th>
                        </tr>
                      </thead>

                      <tbody>
                        {customerInvoiceData?.map((u, index) => {
                          const isChecked = customerInvoiceData.some(
                            (item) => item.Payment == item.Openingbalance
                          );
                          // const isChecked = checkedItems.includes(u);
                          return (
                            <tr key={index}>
                              <td className="pt-0 pb-0">
                                <input
                                  type="checkbox"
                                  onChange={(event) =>
                                    handleCheckboxChange(event, index, u)
                                  }
                                  // checked={checkedItems[index]?.ID === u.ID}
                                  // checked={isChecked}
                                  checked={
                                    customerInvoiceData[index]?.isChecked &&
                                    customerInvoiceData[index]?.isChecked
                                  }
                                  // checked={}
                                ></input>
                              </td>
                              <td className="pt-0 pb-0">{u.InvoiceNo}</td>
                              <td className="pt-0 pb-0">
                                {moment(u.DueDate).format("DD-MM-YYYY")}
                              </td>
                              <td className="pt-0 pb-0">
                                <div style={{ width: "175px" }}>
                                  <Select
                                    // style={{width:"175px"}}
                                    options={paymentMethodOption}
                                    placeholder="Payment Method"
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    // isClearable={true}
                                    styles={selectStyles}
                                    id="PaymentMethod"
                                    name="PaymentMethod"
                                    onChange={(event) =>
                                      handleChangeInput(
                                        event,
                                        "PaymentMethod",
                                        index
                                      )
                                    }
                                    className="custom-search-select"
                                    value={paymentMethodOption.find(
                                      (option) =>
                                        option?.value === u?.PaymentMethod
                                    )}
                                  />
                                  {u.isChecked == true &&
                                    u.PaymentMethod == 0 && (
                                      <p className="text-danger mb-0">
                                        * Select Payment Method
                                      </p>
                                    )}
                                </div>
                              </td>
                              <td className="pt-0 pb-0">
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  placeholder="Reference No."
                                  name="ReferenceNumber"
                                  id="ReferenceNumber"
                                  onChange={(event) =>
                                    handleChangeInput(
                                      event,
                                      "ReferenceNumber",
                                      index
                                    )
                                  }
                                  defaultValue={u.ReferenceNumber}
                                ></input>
                              </td>
                              <td className="pt-0 pb-0 text-right">
                                {u.OriginalAmount
                                  ? parseInt(u.OriginalAmount).toFixed(2)
                                  : "0.00"}
                              </td>
                              <td className="pt-0 pb-0 text-right">
                                {u.Openingbalance
                                  ? parseInt(u.Openingbalance).toFixed(2)
                                  : "0.00"}
                              </td>
                              {Number(allCreditApplied) <= 0 ? (
                                <td className="pt-0 pb-0"> Not Available</td>
                              ) : (
                                <td className="pt-1 pb-0">
                                  <input
                                    style={{ width: "85%" }}
                                    // width="10%"
                                    type="number"
                                    className="form-control form-control-sm numberonly"
                                    name="CreditAppiedValue"
                                    // defaultValue={Number(u.CreditAppiedValue).toFixed(2)}
                                    value={u.CreditAppiedValue}
                                    // onKeyPress={handleKeyPress}
                                    onChange={(event) => {
                                      // isNumber(event);
                                      handleChangeInput(
                                        event,
                                        "CreditAppiedValue",
                                        index
                                      );
                                    }}
                                    max={u.Openingbalance}
                                  />
                                  {/* {parseFloat(allCreditApplied).toFixed(2)} */}

                                  {Number(allCreditApplied) < 0
                                    ? 0
                                    : parseInt(allCreditApplied).toFixed(2)}
                                  {/* {showAvailableCreditError && (
                                  <p className="text-danger mb-0">
                                    * Enter Valid Amount
                                  </p>
                                )} */}
                                </td>
                              )}
                              <td className="pt-0 pb-0">
                                <input
                                  style={{ width: "85%" }}
                                  type="number"
                                  className="form-control form-control-sm numberonly"
                                  name="Payment"
                                  value={u?.Payment}
                                  // defaultValue={Number(u?.Payment).toFixed(2)}
                                  // defaultValue={Number(paymentValue).toFixed(2)}
                                  onChange={(event) =>
                                    handlePayment(event, index)
                                  }
                                  // max={u.Openingbalance}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {/* Handle Clear payment */}
              {customerInvoiceData.length > 0 === true && (
                <>
                  <div className="pull-right">
                    <div>
                      <h6 className="fw-bold ">
                        Amount to Apply:&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className="pull-right">
                          $
                          {parseFloat(
                            amountReceived == -1 ? paymentTotal : amountReceived
                          ).toFixed(2)}
                        </span>
                      </h6>
                      <h6 className="fw-bold">
                        Amount to Credit in Store
                        Account:&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className="pull-right">
                          $
                          {creditSubValue
                            ? parseFloat(creditSubValue).toFixed(2)
                            : parseFloat(0.0).toFixed(2)}
                        </span>
                        {/* {creditSubValue < 0 ? 0 : creditSubValue} */}
                      </h6>
                      <h6 className="fw-bold">
                        Total Credit Applied:&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className="pull-right">
                          $
                          {showAppliedCredit
                            ? parseFloat(showAppliedCredit).toFixed(2)
                            : parseFloat(0.0).toFixed(2)}
                        </span>
                        {/* {creditSubValue < 0 ? 0 : creditSubValue} */}
                      </h6>
                      {/* <button className="btn btn-primary pull-right">Clear Payment</button>
                       */}
                    </div>
                  </div>
                </>
              )}

              <div className="d-flex flex-column-reverse mb-3">
                <div className="p-2 col-md-3">
                  Memo:
                  <textarea
                    className="form-control"
                    name="Memo"
                    placeholder="Note"
                    style={{ width: "410px", height: "150px" }}
                    onChange={(event) => handleChangeInput(event, "Memo")}
                    defaultValue={memoData}
                  ></textarea>
                </div>
                <div className="p-2 col-md-4">
                  Attachment:
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    id="Attachment"
                    name="Attachment"
                    accept=".pdf,.jpg,.jpeg,.heic,.png"
                    onChange={handleFileChange}
                  />
                  {attachmentUrl && (
                    <Link to={attachmentUrl} target="_blank">
                      Attachment Link
                    </Link>
                  )}
                </div>
              </div>
              {showAvailableCreditError && (
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    className="btn btn-sm btn-success mt-3 mb-3"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-sm btn-primary mt-3 mb-3"
                    onClick={(e) => handleSubmit(e, "saveandclose")}
                  >
                    Save & Close
                  </button>
                  <button
                    className="btn btn-sm btn-primary mt-3 mb-3"
                    onClick={(e) => handleSubmit(e, "saveandnew")}
                  >
                    Save & New
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceivePayment;
